import React from "react";
import ReactDOM from "react-dom";
import loadingSpinner from "../../assets/images/loading-spinner.gif";
import successIcon from "../../assets/images/congrats.png";
import errorIcon from "../../assets/images/error.png";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import studio from "../../components/modals/StudioModal.module.css";

interface UnifiedSingleTrackCreationModalProps {
    isOpen: boolean;
    status: "waiting" | "success" | "error";
    onClose: () => void;
    onCreateAnother: () => void;
    onGoToContentList: () => void;
}

const UnifiedSingleTrackCreationModal: React.FC<UnifiedSingleTrackCreationModalProps> = ({
    isOpen,
    status,
    onClose,
    onCreateAnother,
    onGoToContentList,
}) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    if (!isOpen) return null;

    const getStatusContent = () => {
        switch (status) {
            case "waiting":
                return {
                    img: loadingSpinner,
                    title: t("creatingTrack"),
                    subtitle: t("pleaseWaitWhileCreating"),
                };
            case "success":
                return {
                    img: successIcon,
                    title: t("trackCreated"),
                    subtitle: t("whatDoYouWantToDo"),
                };
            case "error":
                return {
                    img: errorIcon,
                    title: t("trackCreationFailed"),
                    subtitle: t("pleaseTryAgainLater"),
                };
            default:
                return { img: loadingSpinner, title: "", subtitle: "" };
        }
    };

    const { img, title, subtitle } = getStatusContent();

    const modal = (
        <div className={studio.overlayTop}>
            <div className={studio.contentAnimated}>
                <div className={studio.logoWrap}>
                    <img src={img} alt="Status" style={{ width: 100, height: 100 }} />
                </div>
                <h1 className={studio.title}>{title}</h1>
                <p className={studio.subtitle}>{subtitle}</p>

                <div className={studio.buttonsCentered}>
                    {status === "success" && (
                        <>
                            <Button
                                variant="outline"
                                shape="pill"
                                label={t("createAnother")}
                                onClick={onCreateAnother}
                            />
                            <Button variant="primary" label={t("goToContentList")} onClick={onGoToContentList} />
                        </>
                    )}
                    {status === "error" && <Button variant="cancel" label={t("close")} onClick={onClose} />}
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modal, document.body);
};

export default UnifiedSingleTrackCreationModal;
